export default __webpack_public_path__ + "static/media/password_256.9786de69.png";